import ApiService from './ApiService';

export default {

    sendFeedback(data) {
        return ApiService.post('rating-feedback', data);
    },
}